// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, Alert, Tooltip, Container, Typography } from '@mui/material';
// hooks
import { useTranslation } from 'react-i18next';
import useResponsive from '../../hooks/useResponsive';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import Image from '../../components/Image';
// sections
import { LoginForm } from '../../sections/auth/login';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({



  
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const Login = () => {
  const { t } = useTranslation();

  const mdUp = useResponsive('up', 'md');
  return (
    <Page title="ورود">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Card
              sx={{
                padding: 4,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: 'center',
              }}
            >
              {' '}
              <Logo />
              <Box sx={{ display: 'inline-flex', flexDirection: 'initial', alignItems: 'center', mb: 3 }}>
                <Typography variant="h4" sx={{ mt: 1 }}>
                  ورود به حساب کاربری
                </Typography>
              </Box>
              <Stack direction="column" spacing={3}>
                {/* <Typography sx={{ color: 'text.secondary' }}>{t('description')}</Typography> */}
                <LoginForm />
              </Stack>
            </Card>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
};

export default Login;
